// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import LDAPWizard from './ldap_wizard';

export default LDAPWizard;
